<div class="fs-2" mat-dialog-title>
    Bienvenue sur LyBox
<!--    <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle" /><b>Thomas</b> de LyBox<br/>-->
</div>
<div mat-dialog-content>
    <div class="step1 step" [hidden]="step != 'step1'">
        Bonjour et bienvenue,<br/>
        <br/>
        Vous êtes au bon endroit pour faire votre prochain <b>investissement rentable !</b><br/>
        <br/>
        Je suis Thomas, cofondateur de Lybox et je vais vous <b>accompagner dans vos premiers pas avec l’application.</b><br/>
        <br/>
        LyBox va vous permettre <b>d'accélérer, optimiser et sécuriser</b> vos prochains investissements immobiliers.<br/>
        <br/>
        <b class="text-primary text-center d-block">
            Que vous soyez novice, expérimenté ou même professionnel de l'immobilier :<br/> LyBox est fait pour vous !
        </b>
        <br/>
        Pour améliorer votre expérience sur le site, aidez-nous à mieux vous connaître.<br/>
        <br/>
        <div class="text-center">
            <button type="button" (click)="step = 'step2'" class="btn btn-primary ps-5 pe-5">
                <i class="fa fa-play me-3" aria-hidden="true"></i> Commencer
            </button>
        </div>
    </div>
    <div class="step2 step" [hidden]="step != 'step2'">
        <b class="subtitle">Pour commencer, quel est votre profil d'investisseur ?</b>
        <div class="main-card">
            <ul class="nav nav-tabs search-type mt-4 mb-4 profil justify-content-center">
                <li class="nav-item col-xxl-2 col-md-4">
                    <a [ngClass]="{'nav-link': true, 'active': profil == 'debutant'}"
                       (click)="profil = 'debutant'">
                        <i class="icon icon-profil_debutant"></i>
                        Investisseur débutant
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </li>
                <li class="nav-item col-xxl-2 col-md-4">
                    <a [ngClass]="{'nav-link': true, 'active': profil == 'expert'}"
                       (click)="profil = 'expert'">
                        <i class="icon icon-profil_expert"></i>
                        Investisseur confirmé
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </li>
                <li class="nav-item col-xxl-2 col-md-4">
                    <a [ngClass]="{'nav-link': true, 'active': profil == 'pro'}"
                       (click)="profil = 'pro'">
                        <i class="icon icon-profil_pro"></i>
                        Professionnel de l'immobilier
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </li>
            </ul>
            <div class="text-center">
                <button type="button" [disabled]="profil == ''" (click)="step = 'step3'" class="btn btn-primary ps-5 pe-5">
                    <i class="fa fa-arrow-right me-3" aria-hidden="true"></i> Suivant
                </button>
            </div>
        </div>
    </div>
    <div class="step3 step" [hidden]="step != 'step3'">
        <b *ngIf="profil == 'pro'" class="subtitle">Quels est votre coeur de métier ?</b>
        <b *ngIf="profil != 'pro'" class="subtitle">Quels type d'opération souhaitez vous réaliser ?</b>
        <div class="main-card">
            <ul class="nav nav-tabs search-type mt-4 mb-4 profil justify-content-center">
                <li class="nav-item col-xxl-2 col-md-4">
                    <a [ngClass]="{'nav-link': true, 'active': op == 'locatif'}"
                       (click)="op = 'locatif'">
                        <i class="icon icon-op_locatif"></i>
                        Investissement locatif
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </li>
                <li class="nav-item col-xxl-2 col-md-4" *ngIf="profil == 'pro'">
                    <a [ngClass]="{'nav-link': true, 'active': op == 'chasse'}"
                       (click)="op = 'chasse'">
                        <i class="icon icon-op_chasse"></i>
                        Chasse<br/>immobilière
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </li>
                <li class="nav-item col-xxl-2 col-md-4" *ngIf="profil == 'pro'">
                    <a [ngClass]="{'nav-link': true, 'active': op == 'agence'}"
                       (click)="op = 'agence'">
                        <i class="icon icon-op_agence"></i>
                        Agence<br/>immobilière
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </li>
                <li class="nav-item col-xxl-2 col-md-4" *ngIf="profil == 'pro'">
                    <a [ngClass]="{'nav-link': true, 'active': op == 'gestion_patrimoine'}"
                       (click)="op = 'gestion_patrimoine'">
                        <i class="icon icon-op_gestion_patrimoine"></i>
                        Gestion de patrimoine
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </li>
                <li class="nav-item col-xxl-2 col-md-4">
                    <a [ngClass]="{'nav-link': true, 'active': op == 'mdb'}"
                       (click)="op = 'mdb'">
                        <i class="icon icon-op_mdb"></i>
                        Achat/revente<br/>
                        Marchand de biens
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </li>
                <li class="nav-item col-xxl-2 col-md-4" *ngIf="profil == 'pro'">
                    <a [ngClass]="{'nav-link': true, 'active': op == 'promotion'}"
                       (click)="op = 'promotion'">
                        <i class="icon icon-op_promotion"></i>
                        Promotion immobilière
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </li>
                <li class="nav-item col-xxl-2 col-md-4" *ngIf="profil != 'pro'">
                    <a [ngClass]="{'nav-link': true, 'active': op == 'rp'}"
                       (click)="op = 'rp'">
                        <i class="icon icon-op_rp"></i>
                        Résidence principale ou secondaire
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </li>
                <li class="nav-item col-xxl-2 col-md-4">
                    <a [ngClass]="{'nav-link': true, 'active': op == 'other'}"
                       (click)="op = 'other'">
                        <i class="icon icon-empty"></i>
                        Autre
                        <span class="check"><i class="fa fa-check"></i></span>
                    </a>
                </li>
            </ul>
            <div class="text-center">
                <button type="button" [disabled]="op == ''" (click)="step = 'step4'" class="btn btn-primary ps-5 pe-5">
                    <i class="fa fa-arrow-right me-3" aria-hidden="true"></i> Suivant
                </button>
            </div>
        </div>
    </div>

    <div class="step4 step" [hidden]="step != 'step4'">
        <ng-container *ngIf="profil == 'pro'">
            <b class="subtitle">Quelle est la taille de votre entreprise ?</b>
            <div class="main-card">
                <ul class="nav nav-tabs search-type mt-4 mb-4 profil justify-content-center">
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': pro_size == '1'}"
                           (click)="pro_size = '1'">
                            <i class="icon icon-pro_size-1"></i>
                            Entre 1 et 3 personnes
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': pro_size == '4'}"
                           (click)="pro_size = '4'">
                            <i class="icon icon-pro_size-4"></i>
                            Entre 4 et 10 personnes
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': pro_size == '10'}"
                           (click)="pro_size = '10'">
                            <i class="icon icon-pro_size-10"></i>
                            Plus de 10 personnes
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                </ul>
            </div>
        </ng-container>
        <ng-container *ngIf="profil != 'pro'">
            <b class="subtitle">Quel est la taille de votre patrimoine actuel (hors résidence principale) ?</b>
            <div class="main-card">
                <ul class="nav nav-tabs search-type mt-4 mb-4 profil justify-content-center">
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': patrimoine_size == '0'}"
                           (click)="patrimoine_size = '0'">
                            <i class="icon icon-patrimoine_size-0"></i>
                            Aucun bien
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': patrimoine_size == '1'}"
                           (click)="patrimoine_size = '1'">
                            <i class="icon icon-patrimoine_size-1"></i>
                            Entre 1 et 3 biens
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': patrimoine_size == '3'}"
                           (click)="patrimoine_size = '3'">
                            <i class="icon icon-patrimoine_size-3"></i>
                            Plus de 3 biens
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                </ul>
            </div>
        </ng-container>

        <div class="text-center">
            <button type="button" [disabled]="pro_size == '' && patrimoine_size == ''" (click)="step = 'step5'" class="btn btn-primary ps-5 pe-5">
                <i class="fa fa-arrow-right me-3" aria-hidden="true"></i> Suivant
            </button>
        </div>
    </div>
    <div class="step5 step" [hidden]="step != 'step5'">
            <b class="subtitle">Quel est votre secteur de recherche ?</b>
            <div class="main-card">
                <ul class="nav nav-tabs search-type mt-4 mb-4 profil justify-content-center">
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': zone == 'home'}"
                           (click)="zone = 'home'">
                            <i class="icon icon-zone_home"></i>
                            Autour de chez moi
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': zone == 'district'}"
                           (click)="zone = 'district'">
                            <i class="icon icon-zone_disctrict"></i>
                            Un département / Région
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': zone == 'france'}"
                           (click)="zone = 'france'">
                            <i class="icon icon-zone_france"></i>
                            France entière
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                </ul>
            </div>

        <div class="text-center">
            <button type="button" [disabled]="zone == ''" (click)="step = 'step6'" class="btn btn-primary ps-5 pe-5">
                <i class="fa fa-arrow-right me-3" aria-hidden="true"></i> Suivant
            </button>
        </div>
    </div>
    <div class="step6 step" [hidden]="step != 'step6'">
            <b class="subtitle">Comment avez vous connu LyBox ?</b>
            <div class="main-card">
                <ul class="nav nav-tabs search-type mt-4 mb-4 profil justify-content-center">
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Facebook'}"
                           (click)="source = 'Facebook'">
                            <i class="icon icon-source_facebook"></i>
                            Facebook
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Twitter'}"
                           (click)="source = 'Twitter'">
                            <i class="icon icon-source_twitter"></i>
                            Twitter
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Instagram'}"
                           (click)="source = 'Instagram'">
                            <i class="icon icon-source_instagram"></i>
                            Instagram
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Tik Tok'}"
                           (click)="source = 'Tik Tok'">
                            <i class="icon icon-source_tiktok"></i>
                            Tik Tok
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Youtube'}"
                           (click)="source = 'Youtube'">
                            <i class="icon icon-source_youtube"></i>
                            Youtube
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Linked\'In'}"
                           (click)="source = 'Linked\'In'">
                            <i class="icon icon-source_linkedin"></i>
                            Linked'In
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Recherche Google'}"
                           (click)="source = 'Recherche Google'">
                            <i class="icon icon-source_google"></i>
                            Recherche Google
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Newletter'}"
                           (click)="source = 'Newletter'">
                            <i class="icon icon-source_newsletter"></i>
                            Newletter
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Bouche à oreille'}"
                           (click)="source = 'Bouche à oreille'">
                            <i class="icon icon-source_friends"></i>
                            Bouche à oreille
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Salon immobilier'}"
                           (click)="source = 'Salon immobilier'">
                            <i class="icon icon-source_salon"></i>
                            Salon immobilier
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Podcast'}"
                           (click)="source = 'Podcast'">
                            <i class="icon icon-source_podcast"></i>
                            Podcast
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Partenaire / Formateur'}"
                           (click)="source = 'Partenaire / Formateur'">
                            <i class="icon icon-source_partner"></i>
                            Partenaire / Formateur
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Presse'}"
                           (click)="source = 'Presse'">
                            <i class="icon icon-source_presse"></i>
                            Presse
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                    <li class="nav-item col-xxl-2 col-md-4">
                        <a [ngClass]="{'nav-link': true, 'active': source == 'Other'}"
                           (click)="source = 'Other'">
                            <i class="icon icon-empty"></i>
                            Autre
                            <span class="check"><i class="fa fa-check"></i></span>
                        </a>
                    </li>
                </ul>
            </div>

        <div class="text-center">
            <button type="button" [disabled]="source == ''" (click)="step = 'step7'" class="btn btn-primary ps-5 pe-5">
                <i class="fa fa-arrow-right me-3" aria-hidden="true"></i> Suivant
            </button>
        </div>
    </div>

    <div class="step7 step" [hidden]="step != 'step7'">
        <b class="subtitle">Pour finir, quel est votre age ?</b>
        <div class="main-card mt-4 mb-4" style="max-width: 300px;">
            <mat-form-field>
                <mat-label>Age</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="age">
                <span matSuffix>ans</span>
            </mat-form-field>
        </div>

        <div class="text-center">
            <button type="button" [disabled]="age == ''" (click)="step = 'step8'" class="btn btn-primary hide-mobile ps-5 pe-5">
                <i class="fa fa-check me-3" aria-hidden="true"></i> Terminer
            </button>
            <button type="button" [disabled]="age == ''" (click)="onNoClick()" class="btn btn-primary visible-mobile ps-5 pe-5">
                <i class="fa fa-check me-3" aria-hidden="true"></i> Terminer
            </button>
        </div>
    </div>

    <div class="step8 step" *ngIf="step == 'step8'">
        <iframe width="100%" height="456" class="mb-3" src="https://www.youtube.com/embed/FxmZ48Yr-y8?autoplay=1" title="Bienvenue sur lybox" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
<!--        Nous avons mis en place une <b>visite guidée</b> pour vous aider à prendre en main l’application LyBox.<br/>-->
<!--        <br/>-->
<!--        Cette visite vous permet de découvrir <b>les différentes fonctionnalités de LyBox</b>.<br/>-->
<!--        <br/>-->
<!--        Si vous ne connaissez pas encore toutes les fonctionnalités de l’application, alors je vous conseille de faire la visite.<br/>-->
<!--        <br/>-->
<!--        Si vous avez un doute, un petit tour rapide devrait <b>vous aider dans vos recherches</b> 🙂<br/>-->
<!--        <br/>-->
<!--        <b>Regardons ensemble la visite guidée de l’application</b><br/>-->
<!--        <br/>-->
        <div class="text-center">
            <button (click)="onYesClick()" type="button" class="btn btn-primary">
                <i class="fa fa-play me-3" aria-hidden="true"></i> Commencer
            </button>
        </div>
    </div>
</div>
